import { g as d } from "../../utils-BOfnFgIH.js";
import { I as l } from "../../constants-DeVuDy8J.js";
import { openBlock as n, createElementBlock as s, normalizeClass as o, createElementVNode as e } from "vue";
import { _ as u } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconPauseCircleFilled",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(l).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return l[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = d();
  }
}, f = ["aria-label", "data-qa", "aria-hidden"], p = ["clip-path"], m = ["id"];
function _(a, i, r, h, v, t) {
  return n(), s("svg", {
    "aria-label": r.ariaLabel,
    class: o([t.iconSizeClass, "d-icon d-icon--pause-circle-filled"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Pause Circle Filled",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    e("g", {
      "clip-path": `url(#${a.uniqueID}a)`
    }, [...i[0] || (i[0] = [
      e("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M11.438 6A5.438 5.438 0 1 0 .563 6a5.438 5.438 0 0 0 10.875 0ZM5 4.064a.437.437 0 0 0-.437.438v3a.438.438 0 0 0 .875 0v-3A.437.437 0 0 0 5 4.063Zm2 0a.437.437 0 0 0-.437.438v3a.438.438 0 0 0 .875 0v-3A.437.437 0 0 0 7 4.063Z",
        fill: "currentColor"
      }, null, -1)
    ])], 8, p),
    e("defs", null, [
      e("clipPath", {
        id: `${a.uniqueID}a`
      }, [...i[1] || (i[1] = [
        e("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z"
        }, null, -1)
      ])], 8, m)
    ])
  ], 10, f);
}
const C = /* @__PURE__ */ u(c, [["render", _]]);
export {
  C as default
};
//# sourceMappingURL=pause-circle-filled.js.map
